export default __webpack_public_path__ + "static/media/DE.ada87df9.png";